import React from 'react';
import PreFormGeneric from '../../common/PreFormGeneric';
import { useLocation } from 'react-router-dom';

const SelectProductMobile = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const motiveId = params.get('motiveId');
  const issueFormName = params.get('issueFormName');
  return (
    <PreFormGeneric mobile motiveId={motiveId} issueFormName={issueFormName} />
  );
};

export default SelectProductMobile;
